let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("frHYK")).then(() => parcelRequire('ldK5O'));